<template>
    <div class="alert alert-danger p-4">
        <div class="font-bold text-xl mb-2">
            Аккаунт заблокирован
        </div>
        <div class="font-bold" v-html="ban.reasonHtml"></div>

        <div v-if="!ban.permanent">
            До
            <smartdate
                    class="inline"
                    :date="ban.banned_until"
                    :direct="1"
                    :ignore-future="1"
            ></smartdate>
        </div>
    </div>
</template>
<script>
export default {
    props: ['ban'],
}
</script>